import momentImported from 'moment'; 
const moment = momentImported;

export class DateHelper {
    
    public static getIsoDateString(date: Date): string{
            return moment(date).format('YYYY-MM-DD');
    }

    public static getIsoTimeString(date: Date): string{
            return moment(date).format('HH:mm');
    }

    public static getIsoDateTimeString(date: Date): string{
            return moment(date).toISOString();
    }
}